/*
 * playbackCapability — decides whether single-cam playback should use the
 * WebCodecs canvas player (PlaybackPlayer, with b2 SEI overlays + HUD) or the
 * legacy native <video>.
 *
 * WebCodecs is used for both LOCAL and eVIEW NVR clips: both are the same
 * non-fragmented mpengine MP4s served by pbserver's `camstream fetch`, and both
 * carry b2 SEI in the video NALs. They differ only in auth (session vs user/pass)
 * and, for a remote member NVR, origin — but pbserver sends
 * `Access-Control-Allow-Origin: *` (and the C pbserver also exposes Content-Range),
 * so the WebCodecs ranged fetch works cross-origin too. If a member NVR ever can't
 * be fetched (e.g. an old build without CORS-exposed ranges), the player's onError
 * path falls the clip back to <video> — the pre-existing safety net — so enabling
 * eView here is strictly no worse than before.
 *
 * Cloud (CloudVS) clips still keep <video> — NOT because the bytes lack SEI
 * (they don't: iSite stream-copies the mpengine bitstream, so b2 survives), but
 * because a ranged WebCodecs fetch can't yet authenticate to the clip. cloudapi
 * serves the videostore MP4 with Range + a cross-origin-readable Content-Range,
 * but the route takes auth ONLY as an `Authorization: Bearer <jwt>` header (the
 * `?token=` query param was removed) and only echoes CORS for a whitelisted
 * origin. The current CloudVS URL uses `?token=`, so a fetch would 401. Enabling
 * cloud is a real follow-up (Bearer-header fetch + origin whitelist), not a flag
 * flip. Any browser without WebCodecs (e.g. Firefox) also stays on <video>.
 */

export function webCodecsPlaybackSupported() {
	return (
		typeof window !== 'undefined' &&
		typeof window.VideoDecoder !== 'undefined' &&
		typeof window.EncodedVideoChunk !== 'undefined'
	);
}

// props: { cloud, fEview } — from PlayerWindow's Redux mapping.
export function shouldUseWebCodecs(props = {}) {
	if (!webCodecsPlaybackSupported()) return false;
	if (props.cloud) return false;   // cloud clips keep <video> because ranged fetch auth is not wired
	return true;                     // local + eView: mpengine MP4s with b2 SEI, pbserver CORS
}
